import BulkActions from './BulkActions';

export default BulkActions;
